import { forwardRef, type ButtonHTMLAttributes } from 'react';

import { cn } from '../lib/cn';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant = 'primary', type = 'button', ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex h-10 items-center justify-center rounded-xl px-5 text-[13px] font-semibold tracking-wide transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)]',
        'disabled:pointer-events-none disabled:opacity-50',
        variant === 'primary' &&
          'bg-[var(--btn-primary-bg)] text-[var(--btn-primary-fg)] hover:bg-[var(--btn-primary-bg-hover)]',
        variant === 'secondary' &&
          'border border-[var(--btn-secondary-border)] bg-[var(--btn-secondary-bg)] text-[var(--btn-secondary-fg)] hover:bg-[var(--btn-secondary-bg-hover)]',
        variant === 'ghost' && 'bg-transparent text-[var(--accent)] hover:bg-[var(--bg-soft)]',
        variant === 'danger' &&
          'bg-[var(--error-text)] text-white hover:bg-[color-mix(in_srgb,var(--error-text)_85%,black)]',
        className
      )}
      {...props}
    />
  );
});
